export const getSanteClairToken = state => state.pages.reseauSoin.santeClair.data
export const isSanteClairTokenLoading = state => state.pages.reseauSoin.santeClair.loading
export const getExpirationDate = state => state.pages.reseauSoin.santeClair.expirationDate
